export const octicons = () => `
  .octicon {
    display: inline-block;
    vertical-align: text-top;
    margin-right: 1rem;
    vertical-align: middle;
  }
`
